import {canViewShareLinks} from './canViewShareLinks';

export const canCreateShareLink = (): boolean => canViewShareLinks();
